import { render, staticRenderFns } from "./GiftHistory.vue?vue&type=template&id=426dd0ea&scoped=true&"
import script from "./GiftHistory.vue?vue&type=script&lang=js&"
export * from "./GiftHistory.vue?vue&type=script&lang=js&"
import style0 from "./GiftHistory.vue?vue&type=style&index=0&id=426dd0ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426dd0ea",
  null
  
)

export default component.exports